import * as yup from "yup"
import { ErrorMessages } from "logics/const"

export default function stringOptional() {
  return yup.string().nullable()
}
